export const worldMap = {
  reset: "reset",
  resetMapSelections: "Réinitialisation des sélections de cartes",
  zoomIn: "Zoomer en avant",
  zoomOut: "Effectuer un zoom arrière",
  indicatorPanel: {
    indicatorPanelTitle:
      "L'état de la santé numérique dans le monde aujourd'hui",
    noHealthIndicatorAvailable: "Aucun indicateur de santé disponible",
    noDigitalIndicatorAvailable:
      "Aucun indicateur de santé mondiale disponible",
    viewCountries: "Voir les pays",
    viewDetails: "Voir les détails",
    context: {
      text: "Contexte",
      gniPerCapita: "RNB par habitant, méthode de l'atlas (en dollars)",
      totalPopulation: "Population totale",
      adultLiteracyRate:
        "Taux d'alphabétisation des adultes, population de 15 ans et plus, les deux sexes (%)",
      easeOfDoingBusinessIndex: "facilité de faire des affaires",
    },
    health: {
      text: "Santé",
      lifeExpectancy: "Espérance de vie à la naissance (années)",
      healthExpenditure: "Dépenses de santé (% du PIB)",
      causeOfDeath:
        "Cause des décès par maladies non-transmissibles (% du total)",
      mortalityRate:
        "Taux de mortalité des moins de 5 ans (pour 1 000 naissances vivantes)",
    },
    description:
      "L’Moniteur de santé numérique mondial (GDHM) est une ressource interactive en ligne qui vise à suivre, surveiller et évaluer " +
      "l'environnement favorable à la santé numérique dans le monde.",
  },
  searchCountry: "Rechercher un pays",
  note: "Fabriqué avec de la terre naturelle.",
  note1: "Frontières de l'Inde",
  note2: "par",
  note3: "Communauté DataMeet Inde",
};
